import React from 'react'
import {useTranslation} from 'react-i18next'

type IProps = {
 selectedCommodities: string[]
 setSelectedCommodities: React.Dispatch<
  React.SetStateAction<string[]>
 >
}

export const COMMODITY_OPTIONS = [
 {key: 'dry', labelKey: 'dry', apiValue: 'DRY'},
 {
  key: 'fruits_and_vegetables',
  labelKey: 'fruitsAndVegetables',
  apiValue: 'FV',
 },
] as const

export const mapSelectedToCommodityProfile = (
 selected: string[]
): string[] =>
 COMMODITY_OPTIONS.filter((option) =>
  selected.includes(option.key)
 ).map((option) => option.apiValue)

export const mapCommodityProfileToSelected = (
 profile?: string[] | null
): string[] => {
 if (!Array.isArray(profile)) return []
 return COMMODITY_OPTIONS.filter((option) =>
  profile.includes(option.apiValue)
 ).map((option) => option.key)
}

const CommodityProfile = (props: IProps) => {
 const {t} = useTranslation()

 const toggleCommodity = (key: string) => {
  props.setSelectedCommodities((prev) =>
   prev.includes(key)
    ? prev.filter((item) => item !== key)
    : [...prev, key]
  )
 }

 return (
  <div className='w-full'>
   <div className='text-[#33393D] text-lg font-bold mb-4'>
    {t(
     'myAccountPage.businessProfile.offtaker.commodityProfile.title'
    )}
    <span className='text-[#E03137] pl-[2px]'>*</span>
   </div>
   <div className='grid md:grid-cols-2 gap-4'>
    {COMMODITY_OPTIONS.map((option) => {
     const isSelected = props.selectedCommodities.includes(
      option.key
     )
     return (
      <button
       key={option.key}
       type='button'
       onClick={() => toggleCommodity(option.key)}
       className={`flex items-center gap-3 w-full min-h-[56px] px-4 py-3 rounded-lg border bg-white text-left cursor-pointer ${
        isSelected ? 'border-[#4E83E4]' : 'border-[#E6EBF0]'
       }`}
      >
       <span
        className={`flex items-center justify-center w-5 h-5 rounded border ${
         isSelected
          ? 'border-[#4E83E4] bg-[#4E83E4]'
          : 'border-[#4E83E4] bg-white'
        }`}
       >
        {isSelected && (
         <span className='text-white text-xs font-bold leading-none'>
          ✓
         </span>
        )}
       </span>
       <span className='text-[#33393D] text-base font-medium'>
        {t(
         `myAccountPage.businessProfile.offtaker.commodityProfile.${option.labelKey}`
        )}
       </span>
      </button>
     )
    })}
   </div>
  </div>
 )
}

export default CommodityProfile
